// Clients
import myrianderClient from './clients/Myriander'
import fonestormClient from './clients/FoneStorm/FoneStorm.vue'
import cdrClient from './clients/CDR/CDR.vue'
// Original Objects
import addObject from './components/objects/Add.vue'
import updateObject from './components/objects/Update.vue'
import updateMultiple from './components/objects/MultiUpdate.vue'
import showObject from './components/objects/Show.vue'
import deleteObject from './components/objects/Delete.vue'
import listObject from './components/objects/table/Table.vue'
import tableHeader from './components/objects/table/Header.vue'
import tableBody from './components/objects/table/Body.vue'
import tablePagination from './components/objects/table/Pagination.vue'
import tablePaginationV2 from './components/objects/table/PaginationV2.vue'
// Active-Disabled
import tableBodyDisabled from './components/objects/table/BodyDisabled.vue'
import listObjectActive from './components/objects/table/TableActive.vue'
import listObjectDisabled from './components/objects/table/TableDisabled.vue'
// vue-mc Objects
import mcShowObject from './components/vue-mc/Show.vue'
import mcEditObject from './components/vue-mc/Edit.vue'

const FractelDashboardPlugin = {
  install (Vue, options) {
    [
      // Clients
      myrianderClient,
      fonestormClient,
      cdrClient,
      // Original Objects
      addObject,
      updateObject,
      updateMultiple,
      showObject,
      deleteObject,
      listObject,
      tableHeader,
      tableBody,
      tablePagination,
      tablePaginationV2,
      tableBodyDisabled,
      listObjectActive,
      listObjectDisabled,
      // vue-mc Objects
      mcShowObject,
      mcEditObject
    ].forEach(component => {
      Vue.component(component.name, component)
    })
  }
}

export default FractelDashboardPlugin



// WEBPACK FOOTER //
// ./src/fractel/fractel-dashboard-plugin.js